
import { useSEO, generateBreadcrumbSchema } from '../../utils/seo';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SubmitEventHero from './components/SubmitEventHero';
import EventSubmissionForm from './components/EventSubmissionForm';
import SubmissionGuidelines from './components/SubmissionGuidelines';
import ConfirmationEmailPreview from './components/ConfirmationEmailPreview';

export default function SubmitEventPage() {
  useSEO({
    title: 'Submit Your Event | List Community Events in Roseville CA | Roseville.org',
    description: 'Submit your event to be listed on Roseville.org\'s community calendar. Free event listings for festivals, concerts, markets, classes, and community gatherings in Roseville, California.',
    keywords: 'submit event Roseville, list event Roseville CA, Roseville community calendar submission, add event Roseville, Roseville event listing',
    canonical: '/submit-event',
    ogImage: 'https://public.readdy.ai/ai/img_res/f3baebe4a66bbea7dd518bf96c171306.jpg',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          name: 'Submit Your Event — Roseville Community Calendar',
          description: 'Submit your community event for listing on the Roseville.org events calendar.',
          url: `${import.meta.env.VITE_SITE_URL || 'https://roseville.org'}/submit-event`,
          inLanguage: 'en-US',
        },
        generateBreadcrumbSchema([
          { name: 'Home', url: '/' },
          { name: 'Events', url: '/events' },
          { name: 'Submit Your Event', url: '/submit-event' },
        ]),
      ],
    },
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <SubmitEventHero />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <EventSubmissionForm />
          </div>
          <div className="lg:col-span-1 space-y-6">
            <SubmissionGuidelines />
            <ConfirmationEmailPreview />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
